<div *ngIf="role" class="container-fluid">
  <div class="text-bidit-primary-header" mat-dialog-title>
    <div *ngIf="role.role_ID">
      <p i18n>Edit Role</p>
    </div>
    <div *ngIf="!role.role_ID">
      <p i18n>Add Role</p>
    </div>
  </div>
  <div mat-dialog-content>
    <p class="form-inline mb-3">
      <span *ngIf="role.role_ID" i18n>To edit the role, changes on the form below then click Submit</span>
      <span *ngIf="!role.role_ID" i18n>To add a new role, complete the form below then click submit</span>
      <span class="float-right warning col-sm-4" i18n>* Required Information</span>
    </p>
    <form #form="ngForm" (ngSubmit)="saveRole(form)">
      <div class="form-group form-inline">
        <span class="warning">* </span>
        <label class="col-md-2" for="name" i18n>Role Name</label>
        <input id="name" name="name" class="form-control col-md-9" [(ngModel)]="role.role_Name"
               required #name="ngModel"
               [class.field-error]="form.submitted && name.invalid">
        <div [hidden]="!form.submitted || name.valid"
             class="alert alert-danger" i18n>Role name is required</div>
      </div>
      <div class="mt-5">
        <h5 i18n>Role Permissions</h5>
        <div class="row row-cols-1 row-cols-md-2">
            <ng-container *ngFor="let rolePerm of rolePermissions">
                <div *ngIf="displayRole(rolePerm)" id="rolePermissions">
                    <div class="card border-0">
                        <div class="card-body">
                            <h5 class="">{{ getRoleModuleName(rolePerm.module_ID)}}</h5>
                            <div *ngFor="let perm of rolePerm.permissions">
                                <mat-checkbox *ngIf="displayPerm(perm)"
                                              id="{{perm.perm_ID}}" name="perm_{{perm.perm_ID}}" [(ngModel)]="perm.isSelected"
                                              [disabled]="readOnlyRole && readOnlyRole != perm.perm_ID" (change)="applyRole(perm)">
                                    {{getRolePermissionName(perm.perm_ID)}}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div *ngIf="errors" class="row alert alert-danger" role="alert">
          <strong>{{errors}}</strong>
        </div>
      </div>
      <mat-dialog-actions align="end">
        <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
        <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
      </mat-dialog-actions>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
      <div class="mt-3">
        <div [hidden]="!form.submitted || form.valid"
             class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
      </div>
    </form>
  </div>
</div>

